module.exports = __webpack_public_path__ + "static/media/DKS-2805_2.e8684843.jpg";